import Vue from 'vue'
import Router from 'vue-router';
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
const routes = [
  {
    path: '/',
    component: resolve => require(["@/view/PrivacyPolicy/Index.vue"], resolve),
    meta: {
      title: 'Choice Bank'
    },
  },
  {
    path: '/privacypolicy',
    component: resolve => require(["@/view/PrivacyPolicy/Index.vue"], resolve),
    meta: {
      title: 'Privacy Policy - Choice Bank'
    },
  },
  {
    path: '/terms',
    component: resolve => require(["@/view/Terms/Index.vue"], resolve),
    meta: {
      title: 'Terms of Service - Choice Bank'
    },
  },

  {
    path: '/bankflow',
    component: resolve => require(["@/view/H5Terms/bankflow.vue"], resolve),
    meta: {
      title: 'Choice Bank'
    },
  },
  {
    path: '/depositguide',
    component: resolve => require(["@/view/H5Terms/depositguide.vue"], resolve),
    meta: {
      title: 'Deposit guide'
    },
  },
  {
    path: '/description',
    component: resolve => require(["@/view/H5Terms/description.vue"], resolve),
    meta: {
      title: 'Group description'
    },
  },
  {
    path: '/frontidcard',
    component: resolve => require(["@/view/H5Terms/frontidcard.vue"], resolve),
    meta: {
      title: 'Choice Bank'
    },
  },
  {
    path: '/guaranteerule',
    component: resolve => require(["@/view/H5Terms/guaranteerule.vue"], resolve),
    meta: {
      title: 'Choice Bank'
    },
  },
  {
    path: '/guarules',
    component: resolve => require(["@/view/H5Terms/guarules.vue"], resolve),
    meta: {
      title: 'Guarantee rules'
    },
  },

  {
    path: '/increaseloan',
    component: resolve => require(["@/view/H5Terms/increaseloan.vue"], resolve),
    meta: {
      title: 'Increase loan limit'
    },
  },
  {
    path: '/introduction',
    component: resolve => require(["@/view/H5Terms/introduction.vue"], resolve),
    meta: {
      title: 'Platform introduction'
    },
  },
  {
    path: '/loancontract',
    component: resolve => require(["@/view/H5Terms/loancontract.vue"], resolve),
    meta: {
      title: 'Loan contract'
    },
  },
  {
    path: '/loanguide',
    component: resolve => require(["@/view/H5Terms/loanguide.vue"], resolve),
    meta: {
      title: 'Loan guide'
    },
  },
  {
    path: '/loanproductdescription',
    component: resolve => require(["@/view/H5Terms/loanproductdescription.vue"], resolve),
    meta: {
      title: 'Loan guide'
    },
  },
  {
    path: '/handidcard',
    component: resolve => require(["@/view/H5Terms/handidcard.vue"], resolve),
    meta: {
      title: 'Choice Bank'
    },
  },


  {
    path: '/repaymentguide',
    component: resolve => require(["@/view/H5Terms/repaymentguide.vue"], resolve),
    meta: {
      title: 'Repayment guide'
    },
  },
  {
    path: '/reverseidcord',
    component: resolve => require(["@/view/H5Terms/reverseidcord.vue"], resolve),
    meta: {
      title: 'Choice Bank'
    },
  },
  {
    path: '/securityagreement',
    component: resolve => require(["@/view/H5Terms/securityagreement.vue"], resolve),
    meta: {
      title: 'Guarantor contract'
    },
  },
  {
    path: '/cashreward',
    component: resolve => require(["@/view/Active/CashReward.vue"], resolve),
    meta: {
      title: 'Cash Reward'
    },
  },
  {
    path: '/conditions',
    component: resolve => require(["@/view/conditions.vue"],resolve),
    meta: {
      title: 'Conditions'
    },
  },
  {
    path: '/privacy',
    component: resolve => require(["@/view/privacy.vue"],resolve),
    meta: {
      title: 'Privacy'
    },
  },
  {
    path: '/c_app',
    component: resolve => require(["@/view/EmailTemplate/c_app.vue"],resolve),
    meta: {
      title: 'Privacy'
    },
  },

];
Vue.use(Router)
const router = new Router({
  // mode: 'history',
  // fallback: false,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {  //如果未匹配到路由
    next('/')
  } else {
    document.title = to.meta.title;
    next()
  }

})
export default router;